export const DAO_CODE = 'DEAL' + '_ORIGIN' + '_DAO';
